import { SettingsMenuItem } from '../types/menu';

export const defaultMenuSettings: SettingsMenuItem[] = [
  {
    name: 'files',
  },
  /*{
    name: 'community',
  },*/
  {
    name: 'support',
  },
  {
    name: 'documentation',
  },
];
